import axios from "axios";

const MENU_ACCESS_API_URL = `${process.env.REACT_APP_API_URL}/menu-access`; // Replace with your actual API URL

const customHeaders = {
  'Content-Type': 'application/json',
};

// Fetch all menu access items
export const fetchMenuAccessItems = async () => {
  const response = await axios.get(MENU_ACCESS_API_URL, { headers: customHeaders });
  return response.data;
};

// Create a new menu access item
export const addMenuAccessItem = async (newMenuAccessItem: { name: string; description: string; is_active: boolean; permissions?: string[] }) => {
  const response = await axios.post(MENU_ACCESS_API_URL, newMenuAccessItem, { 
    headers: customHeaders
  });
  return response.data;
};

// Edit an existing menu access item
export const updateMenuAccessItem = async (updatedMenuAccessItem: { id: string; name: string; description: string; is_active: boolean; permissions?: string[] }) => {
  const response = await axios.put(`${MENU_ACCESS_API_URL}`, updatedMenuAccessItem, { 
    headers: customHeaders
  });
  return response.data;
};
